var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.$permits.has("accessToProVersions")
    ? _c(
        "div",
        {
          staticClass: "roomy message",
          staticStyle: {
            "--message-background": "var(--fa-yellow)",
            "--message-border-width": "0",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "display-flex flex-column tablet:flex-row flex-items-start",
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "margin-top-md tablet:margin-top-0 tablet:margin-left-lg",
                },
                [
                  _c(
                    "h3",
                    { staticClass: "h5 margin-bottom-4xs" },
                    [_vm._t("default")],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "line-length-lg" },
                    [
                      _vm._t("message", function () {
                        return [
                          _c(
                            "p",
                            [
                              _vm._v(
                                "\n            This is a Pro feature so you'll need to\n            "
                              ),
                              _c(
                                "site-link",
                                { attrs: { to: { name: "plans" } } },
                                [_vm._v("grab a Pro-level plan")]
                              ),
                              _vm._v(
                                "\n            to use it. You'll also get thousands more icons, access to services, and support! Already got a plan?\n            "
                              ),
                              _c(
                                "site-link",
                                { attrs: { to: { name: "account" } } },
                                [_vm._v("Sign in!")]
                              ),
                            ],
                            1
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "tag yellow",
        staticStyle: { "--tag-background": "var(--fa-dk-yellow)" },
      },
      [
        _vm._v("\n      Pro\n      "),
        _c("span", { staticClass: "sr-only" }, [_vm._v("Plan Required")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }